<template>
  <b-modal v-model="show" size="md" centered header-bg-variant="primary" hide-footer title="Move Files to Folder" @hide="cancelMoveFolderModal()">
    <div class="d-block uploadCdnImageWrapper">
      <b-row>
        <b-col sm="12" v-if="show">
            <h4>Please Select Folder to move</h4>
            <hr class="m-1">
            <b-row>
              <b-col sm="12">
                <treeselect :options="folderList" v-model="activefolder" :normalizer="normalizer" :max-height="1000" isDefaultExpanded :default-expand-level="1" class="folderWrapper" always-open >
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                    <i class='fa fa-folder-o mr-2'></i> {{ node.label }}
                  </label>
                </treeselect>
              </b-col>
              <b-col sm="12" class="mt-2 text-right">
                <b-button variant="success" @click="changeFolder()" :disabled="activefolder === ''">Change Folder</b-button>
                <b-button variant="outline-danger" @click="cancelMoveFolderModal">Cancel</b-button>
              </b-col>
            </b-row>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { Events } from '../../events.js'
import VueNotifications from 'vue-notifications'

export default {
  props: {
    showMoveFolderModal: {
      type: Boolean,
      default: false
    },
    folderList: {
      type: Array,
      default: function () { return [] }
    },
    updateData: {
      type: Array,
      default: function () { return [] }
    }
  },
  data: () => {
    return {
      activefolder: '',
      processing: false
    }
  },
  components: {
    Treeselect
  },
  computed: {
    show: {
      get: function () {
        return this.showMoveFolderModal
      },
      set: function () {
        return this.showMoveFolderModal
      }
    }
  },
  methods: {
    normalizer (node) {
      return {
        id: node.Id,
        label: node.Name,
        children: node.children
      }
    },
    async changeFolder () {
      try {
        const payload = {
          files: this.updateData,
          folderId: this.activefolder
        }
        await this.$http.post(`${this.API_ENDPOINT}/fileManager/image/moveFolder`, payload, { headers: { 'Content-Type': 'application/json' } })
        this.$emit('uploadFolderImages')
        this.cancelMoveFolderModal()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Folders Updated Successfully.')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    cancelMoveFolderModal () {
      this.activefolder = ''
      this.$emit('cancelMoveFolderModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cdnFileManager/MoveFolderModal.vue